import { MentorsCard } from "@/types/homepage";
import { Star, MessageCircle, Plus } from "lucide-react";
import Link from "next/link";
import { BlueThreeStarts } from "../common/Icons";
import { ImageLogo } from "../common/ImageLogo";

const HomePageCourseCard = ({
  coursesCards,
  index,
}: {
  coursesCards: MentorsCard;
  index: number;
}) => {
  const safeScholarship = coursesCards.scholarship
    ? "Scholarship available — eligibility and university terms apply"
    : undefined;

  const statItems = [
    { label: "Annual Fees", value: coursesCards.annualFees },
  ];

  return (
    <>
      <div
        className={`ff_raleway shadow-[0px_4px_12px_0px_#00000040] rounded-[12px] py-5 px-3 lg:px-4 lg:py-8 h-full relative ${coursesCards.isTopMentorPick ? "bg-[#021A38]" : "bg-white"}`}
      >
        {coursesCards.isTopMentorPick && (
          <div className="absolute top-0 left-[5%] -translate-y-1/2  flex items-center justify-center bg-primary-gradient rounded-full py-[6px] px-3">
            <span
              className={`rounded-[14px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0 w-[calc(100%-5px)] h-[calc(100%-5px)] bg-white`}
            ></span>
            <div className="relative z-10 flex items-center gap-1.5 lg:gap-[10px]">
              <Star fill="black" className="size-[10px] lg:size-3" />
              <p className="font-medium text-[10px] lg:text-xs ff_poppins">
                TOP MENTOR PICK
              </p>
            </div>
          </div>
        )}
        <div className="flex flex-col h-full justify-between">
          <div>
            <div className="flex gap-2 justify-between flex-wrap flex-col">
              <div className="items-center gap-2 flex">
                <div className="bg-white rounded-[16px] md:rounded-[20px] p-2 flex items-center justify-center size-[52px] lg:size-[64px]">
                  <ImageLogo
                    customImageClass={"rounded-xl"}
                    college_name={coursesCards.university ?? ""}
                    country={coursesCards.country ?? ""}
                  />
                </div>
                <p
                  className={`ff_poppins text-xs lg:text-sm capitalize font-medium ${coursesCards.isTopMentorPick ? "text-[#E0E0E0]" : "text-[#374151]"}`}
                >
                  {coursesCards.country?.replaceAll("europe - ", "")}
                </p>
                <span className={`size-[7px] lg:size-[9.32px] rounded-full ${coursesCards.isTopMentorPick ? "bg-[#E0E0E0]" : "bg-[#6B7280]"}`}></span>
              </div>

              <Link
                href="/tools/course-finder?step=qualification"
                className={`text-white ff_poppins text-sm sm:text-base w-full lg:text-lg 3xl:text-xl text-center py-2.5 px-3 rounded-xl shadow-[0px_4px_12px_0px_#FFFFFF40] bg-[#1776F0] min-h-[44px] flex items-center justify-center font-medium`}
              >
                Find Your Course Match
              </Link>
            </div>
            <div className="mt-3 lg:mt-5 flex flex-col gap-1.5">
              <div className="flex items-center gap-3">
                <Link
                  href={`/${coursesCards.courseSlug}`}
                  className={`text-base sm:text-xl lg:text-2xl font-semibold inline-flex items-center gap-1 cursor-pointer min-h-[36px] py-1 ${coursesCards.isTopMentorPick ? "text-white" : "text-black"}`}
                >
                  {coursesCards.title}
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <Link
                  href={`/${coursesCards.courseSlug}`}
                  className={`ff_poppins text-[14px] lg:text-sm flex items-center gap-1 cursor-pointer min-h-[32px] py-1 font-medium ${coursesCards.isTopMentorPick ? "text-[#D1D5DB]" : "text-[#4B5563]"}`}
                >
                  {coursesCards.university}
                </Link>
              </div>
              {coursesCards.mentorTake && (
                <div className={`rounded-[12px] mt-2 lg:mt-3 p-3 lg:p-3.5 ${coursesCards.isTopMentorPick ? "bg-[#0B3B73]" : "bg-[#EBF3FE]"}`}>
                  <div className={`flex items-center gap-[6px] `}>
                    <span className="inline-block size-4 lg:size-[20px]">
                      <BlueThreeStarts
                        colors={
                          coursesCards.isTopMentorPick ? "white" : "#021A38"
                        }
                      />
                    </span>
                    <p
                      className={`text-[10px] sm:text-xs lg:text-sm font-semibold ff_poppins ${coursesCards.isTopMentorPick ? "text-white" : "text-[#021A38]"}`}
                    >
                      Mentor’s Take
                    </p>
                  </div>
                  <p
                    className={`ff_poppins text-[10px] sm:text-xs lg:text-sm font-medium mt-1.5 lg:mt-2 ${coursesCards.isTopMentorPick ? "text-white/95" : "text-[#1E293B]"}`}
                  >
                    {coursesCards.mentorTake}
                  </p>
                </div>
              )}

              <div className="grid grid-cols-3 mt-4 gap-x-2">
                {statItems.map(
                  (item) =>
                    item.value && (
                      <Link href={`/tools/course-finder?step=qualification`}

                        key={item.label}
                        className={`rounded-[8px] p-[10px]  ${coursesCards.isTopMentorPick ? "bg-[#D9D9D94D]" : "bg-[#D4E6FF] "
                          }`}
                      >
                        <p
                          className={`ff_poppins text-[8px] xxs:text-[10px] lg:text-xs font-medium text-center
                            ${coursesCards.isTopMentorPick ? "text-[#DADADA]" : "text-primary"}`}
                        >
                          {item.label}
                        </p>
                        <p
                          className={`text-[8px] xxs:text-[10px] lg:text-sm font-semibold ff_poppins text-center
                            ${coursesCards.isTopMentorPick ? "text-white!" : "text-black!"}`}
                        >
                          {item.value}
                        </p>
                      </Link>
                    )
                )}
              </div>
            </div>
            <div className="mt-4 lg:mt-5 flex items-center justify-start flex-wrap gap-1.5">
              {coursesCards.label &&
                coursesCards.label.map((item, index) => (
                  <Link
                    href={`/tools/course-finder?step=qualification`}
                    key={index}
                    className={`text-[10px] lg:text-xs ff_poppins font-medium py-1 px-2.5 rounded-full ${coursesCards.isTopMentorPick ? "bg-[#FFFFFF5E] text-white" : "bg-[#E5F0FF] text-black"}`}
                  >
                    {item}
                  </Link>
                ))}
              {safeScholarship && (
                <Link
                  href={`/tools/course-finder?step=qualification`}
                  className={`text-[10px] lg:text-xs ff_poppins font-medium py-1 px-2.5 rounded-full ${coursesCards.isTopMentorPick ? "bg-[#FFFFFF5E] text-white" : "bg-[#E5F0FF] text-black"}`}
                >
                  {safeScholarship}
                </Link>
              )}
            </div>

            {/* Bottom Actions Block - Redirects to Course Finder */}
            <div className={`border-t mt-4 pt-4 flex flex-col ${coursesCards.isTopMentorPick ? "border-white/10" : "border-gray-200"}`}>
              <div className="flex items-center gap-3">
                <Link
                  href="/tools/course-finder?step=qualification"
                  className={`w-1/2 rounded-xl lg:rounded-[16px] bg-primary-gradient relative cursor-pointer`}
                >
                  <span
                    className={`rounded-xl lg:rounded-[14px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0 w-[calc(100%-5px)] h-[calc(100%-5px)] ${coursesCards.isTopMentorPick ? "bg-[#021A38]" : "bg-white"}`}
                  ></span>
                  <div
                    className={`relative z-10 p-[10px] flex items-center gap-2 justify-center transition-opacity hover:opacity-85 ${coursesCards.isTopMentorPick ? "text-white" : "text-black"}`}
                  >
                    <MessageCircle className="size-[16px] lg:size-5" />
                    <p className="text-xs lg:text-sm font-medium ff_poppins">
                      Ask about this
                    </p>
                  </div>
                </Link>

                <Link
                  href="/tools/course-finder?step=qualification"
                  className="cursor-pointer inline-block bg-primary-gradient text-white text-xs lg:text-sm font-medium ff_poppins p-[10px] lg:p-[12px] rounded-xl lg:rounded-[16px] w-1/2 text-center hover:opacity-90"
                >
                  Apply via Edvia
                </Link>
              </div>

              <div
                className={`flex items-center justify-center mt-3 gap-1.5 ${coursesCards.isTopMentorPick ? "text-white" : "text-[#546683]"}`}
              >
                <Link
                  href="/tools/course-finder?step=qualification"
                  className="flex items-center justify-center gap-1.5 cursor-pointer hover:opacity-85"
                >
                  <Plus className="size-4" />
                  <p className="text-xs lg:text-sm font-medium ff_poppins">
                    Add to compare
                  </p>
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default HomePageCourseCard;
